module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Settings-2-ed93b9d57191dbfda6ce466dfe15c291.svg";